import React from 'react';
import MainNav from './components/Navigation/MainNav';
import AppRoutes from './routes';
import 'antd/dist/reset.css';
import './components/styles.css';
import './components/Navigation/styles.css';
import './App.css';

const App: React.FC = () => {
    return (
        <div className="app-container">
            <MainNav />
            <div className="app-content">
                <AppRoutes />
            </div>
        </div>
    );
};

export default App;
